import { useEffect, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, Col, Row } from 'antd'
import { SearchOutlined, RedoOutlined, DeleteOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    store_id: any | undefined,
    entry_date: string | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        entry_date: undefined,
        date: null
    }

    const [form] = Form.useForm()
    const [form2] = Form.useForm()
    const [form3] = Form.useForm()

    const [visible1, setVisible1] = useState<boolean>(false)
    const [visible2, setVisible2] = useState<boolean>(false)
    const [visible3, setVisible3] = useState<boolean>(false)

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [data, setData] = useState<any>([])
    const [data2, setData2] = useState<any>([])

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleChange2 = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value
        setReciveMoneyData(reciveD)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (Array.isArray(params.store_id) && params.store_id.length > 0) {
            params.store_id = params.store_id.join(',')

        } else {
            params.store_id = null
        }

        if (params.date) {
            params.entry_date = moment(params.date).format('YYYY-MM-DD')
            delete params.date
        }

        axiosTable.get('/finance_center/business/results_list', {
            params: {
                ...params,
                date_type: 1
            }

        }).then((response: any) => {
            if (response) {
                setData(response.store_results_list)
                setData2([response.total_results])
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.entry_date = moment(params.date).format('YYYY-MM-DD')
            delete params.date
        }

        if (Array.isArray(params.store_id) && params.store_id.length > 0) {
            params.store_id = params.store_id.join(',')

        } else {
            params.store_id = null
        }

        baseAxiosComplete('/finance_center/business/results_excel', {
            params: {
                ...params,
                date_type: 1
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    const resetV1 = () => {
        let detail = _.cloneDeep(reciveMoneyData)
        detail.splice(1, detail.length - 1)
        detail[0].refund_reason = undefined
        detail[0].refund_amount = undefined

        form.setFieldsValue({
            store_id: undefined,
            entry_date: undefined,
            deal_paid_amount: undefined,
            left_paid_amount: undefined,
            continue_paid_amount: undefined,
            other_pay_amount: undefined,
            cash_paid_amount: undefined,
            earnest_money_paid_amount: undefined
        })

        setReciveMoneyData(detail)
    }

    const resetV2 = () => {
        let detail = _.cloneDeep(reciveMoneyData)
        detail.splice(1, detail.length - 1)
        detail[0].refund_reason = undefined
        detail[0].refund_amount = undefined

        form2.setFieldsValue({
            store_id: undefined,
            entry_date: undefined,
            total_paid_amount: undefined,
            cash_paid_amount: undefined,
            photo_total_paid_amount: undefined,
            photo_cash_paid_amount: undefined
        })

        setReciveMoneyData(detail)
    }

    const resetV3 = () => {
        let detail = _.cloneDeep(reciveMoneyData)
        detail.splice(1, detail.length - 1)
        detail[0].refund_reason = undefined
        detail[0].refund_amount = undefined

        form2.setFieldsValue({
            store_id: undefined,
            entry_date: undefined,
            agreement_total_amount: undefined,
            total_paid_amount: undefined,
            cash_paid_amount: undefined,
            train_total_paid_amount: undefined,
            certificate_total_paid_amount: undefined,
            certificate_cash_paid_amount: undefined,
        })

        setReciveMoneyData(detail)
    }

    // 添加退款
    interface reciveRow {
        refund_reason: undefined | number, // 退款原因
        refund_amount: undefined | string, // 退款金额，小数类型
    }

    let reciveMoneyRow: reciveRow = {
        refund_reason: undefined,
        refund_amount: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        refund_reason: undefined,
        refund_amount: undefined
    }])

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营管理 -> 每日经营数据 */}
        <BreadCrumb position={['财务中心', '每日经营数据']} />

        <div className="common-page">
            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectStores multiple={true} value={fetchOtherParams.store_id} onChange={(v: any) => {
                            handleChange(v, 'store_id')
                        }} />
                    </div>
                    <DatePicker style={{ marginRight: 8, marginBottom: 12 }} className="fl" placeholder={'选择日期'} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />

                    <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                    <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
                    <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>

                    <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => {
                        setVisible1(true)
                        resetV1()
                    }} type="dashed" >录入月子数据</Button>
                    <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => {
                        setVisible2(true)
                        resetV2()
                    }} type="dashed" >录入产康数据</Button>
                    <Button className="fl" style={{ marginRight: 5, marginBottom: 12 }} onClick={() => {
                        setVisible3(true)
                        resetV3()
                    }} type="dashed" >录入领佳数据</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true}>
                    <Column fixed title="日期" dataIndex="entry_date" key="entry_date" />
                    <Column fixed title="门店" dataIndex="store_name" key="store_name" />
                    <Column title="月子总实收" dataIndex="yuezi_total_paid_amount" key="yuezi_total_paid_amount" />
                    <Column title="签单实收" dataIndex="yuezi_deal_paid_amount" key="yuezi_deal_paid_amount" />
                    <Column title="尾款实收" dataIndex="yuezi_left_paid_amount" key="yuezi_left_paid_amount" />
                    <Column title="诚意金实收" dataIndex="yuezi_earnest_money_paid_amount" key="yuezi_earnest_money_paid_amount" />
                    <Column title="续住收款" dataIndex="yuezi_continue_paid_amount" key="yuezi_continue_paid_amount" />
                    <Column title="其他收款" dataIndex="yuezi_other_pay_amount" key="yuezi_other_pay_amount" />
                    <Column title="现金实收" dataIndex="yuezi_cash_paid_amount" key="yuezi_cash_paid_amount" />
                    <Column title="合同总金额" dataIndex="yuezi_agreement_total_amount" key="yuezi_agreement_total_amount" />
                    <Column title="签单数" dataIndex="yuezi_deal_count" key="yuezi_deal_count" />
                    <Column title="月子退款金额" dataIndex="yuezi_refund_amount" key="yuezi_refund_amount" />
                    <Column title="产康总实收" dataIndex="chankang_total_paid_amount" key="chankang_total_paid_amount" />
                    <Column title="产康现金实收" dataIndex="chankang_cash_paid_amount" key="chankang_cash_paid_amount" />
                    <Column title="摄影胎发总实收" dataIndex="photo_total_paid_amount" key="photo_total_paid_amount" />
                    <Column title="摄影胎发现金实收" dataIndex="photo_cash_paid_amount" key="photo_cash_paid_amount" />
                    <Column title="产康退款金额" dataIndex="chankang_refund_amount" key="chankang_refund_amount" />
                    <Column title="领佳合同总金额" dataIndex="lingjia_agreement_total_amount" key="lingjia_agreement_total_amount" />
                    <Column title="领佳总实收" dataIndex="lingjia_total_paid_amount" key="lingjia_total_paid_amount" />
                    <Column title="培训总实收" dataIndex="train_total_paid_amount" key="train_total_paid_amount" />
                    <Column title="发证总实收" dataIndex="certificate_total_paid_amount" key="certificate_total_paid_amount" />
                    <Column title="领佳现金实收" dataIndex="lingjia_cash_paid_amount" key="lingjia_cash_paid_amount" />
                    <Column title="领佳退款金额" dataIndex="lingjia_refund_amount" key="lingjia_refund_amount" />
                    <Column title="在住人数" dataIndex="check_in_num" key="check_in_num" />
                    <Column title="当日新增入住" dataIndex="new_check_in" key="new_check_in" />
                    <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
                </Table>
            </div>

            <div className="common-main">
                <h3>当日汇总</h3>

                <Table loading={loading} dataSource={data2} scroll={{ x: 'max-content' }} bordered={true}>
                    <Column fixed title="日期" dataIndex="entry_date" key="entry_date" />
                    <Column className="abc" title="月子总实收" dataIndex="yuezi_total_paid_amount" key="yuezi_total_paid_amount" />
                    <Column title="签单实收" dataIndex="yuezi_deal_paid_amount" key="yuezi_deal_paid_amount" />
                    <Column title="尾款实收" dataIndex="yuezi_left_paid_amount" key="yuezi_left_paid_amount" />
                    <Column title="诚意金实收" dataIndex="yuezi_earnest_money_paid_amount" key="yuezi_earnest_money_paid_amount" />
                    <Column title="续住收款" dataIndex="yuezi_continue_paid_amount" key="yuezi_continue_paid_amount" />
                    <Column title="其他收款" dataIndex="yuezi_other_pay_amount" key="yuezi_other_pay_amount" />
                    <Column title="现金实收" dataIndex="yuezi_cash_paid_amount" key="yuezi_cash_paid_amount" />
                    <Column title="合同总金额" dataIndex="yuezi_agreement_total_amount" key="yuezi_agreement_total_amount" />
                    <Column title="签单数" dataIndex="yuezi_deal_count" key="yuezi_deal_count" />
                    <Column title="月子退款金额" dataIndex="yuezi_refund_amount" key="yuezi_refund_amount" />
                    <Column title="产康总实收" dataIndex="chankang_total_paid_amount" key="chankang_total_paid_amount" />
                    <Column title="产康现金实收" dataIndex="chankang_cash_paid_amount" key="chankang_cash_paid_amount" />
                    <Column title="摄影胎发总实收" dataIndex="photo_total_paid_amount" key="photo_total_paid_amount" />
                    <Column title="摄影胎发现金实收" dataIndex="photo_cash_paid_amount" key="photo_cash_paid_amount" />
                    <Column title="产康退款金额" dataIndex="chankang_refund_amount" key="chankang_refund_amount" />
                    <Column title="领佳合同总金额" dataIndex="lingjia_agreement_total_amount" key="lingjia_agreement_total_amount" />
                    <Column title="领佳总实收" dataIndex="lingjia_total_paid_amount" key="lingjia_total_paid_amount" />
                    <Column title="培训总实收" dataIndex="train_total_paid_amount" key="train_total_paid_amount" />
                    <Column title="发证总实收" dataIndex="certificate_total_paid_amount" key="certificate_total_paid_amount" />
                    <Column title="领佳现金实收" dataIndex="lingjia_cash_paid_amount" key="lingjia_cash_paid_amount" />
                    <Column title="领佳退款金额" dataIndex="lingjia_refund_amount" key="lingjia_refund_amount" />
                    <Column title="在住人数" dataIndex="check_in_num" key="check_in_num" />
                    <Column title="当日新增入住" dataIndex="new_check_in" key="new_check_in" />
                    <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
                </Table>
            </div>
        </div>

        {/* 录入月子数据 */}
        <Modal title="录入月子数据" visible={visible1} onOk={() => {
            // 提交录入
            baseAxiosComplete.post('/finance_center/business/add_yuezi', {
                store_id: form.getFieldValue('store_id'),
                entry_date: form.getFieldValue('entry_date') ? form.getFieldValue('entry_date').format('YYYY-MM-DD') : null,
                deal_paid_amount: form.getFieldValue('deal_paid_amount'),
                continue_paid_amount: form.getFieldValue('continue_paid_amount'),
                other_pay_amount: form.getFieldValue('other_pay_amount'),
                cash_paid_amount: form.getFieldValue('cash_paid_amount'),
                left_paid_amount: form.getFieldValue('left_paid_amount'),
                earnest_money_paid_amount: form.getFieldValue('earnest_money_paid_amount'),
                refund_detail: reciveMoneyData[0].refund_reason === undefined ? [] : reciveMoneyData,

            }).then(res => {
                if (res.status === 0) {
                    resetForm()
                    setVisible1(false)
                    resetV1()
                }
            })

        }} onCancel={() => {
            setVisible1(false)
            resetV1()
        }}>

            <div>
                <p style={{ margin: '0 0 10px 0', fontSize: 16 }}>带<span style={{ color: 'red' }}>*</span>号为必填项</p>
                <Form form={form} {...formItemLayout}>
                    <Form.Item required label="选择门店" name="store_id" >
                        <SelectStores />
                    </Form.Item>
                    <Form.Item required label="日期" name="entry_date" >
                        <DatePicker />
                    </Form.Item>
                    <Form.Item required label="月子签单实收" name="deal_paid_amount" tooltip="签单实收只录入当日合同首付、合同全款总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="月子尾款实收" name="left_paid_amount" tooltip="尾款实收只录入当日尾款总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="月子续住收款" name="continue_paid_amount" tooltip="续住收款只录入当日续住收款总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="其他收款" name="other_pay_amount" tooltip="其他收款录入当日医院陪护、陪护餐、门店售卖其他商品的收款总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="现金实收" name="cash_paid_amount" tooltip="现金实收录入当日所有现金的实收总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="诚意金实收" name="earnest_money_paid_amount" tooltip="诚意金实收只录入当日实收的诚意金总额">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                </Form>

                {reciveMoneyData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={10}>
                        <Select placeholder="退款原因" value={el.refund_reason} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange2(index, 'refund_reason', v)
                        }}>
                            <Option key={1} value={1}>宝宝生病投诉</Option>
                            <Option key={2} value={2}>餐食投诉</Option>
                            <Option key={3} value={3}>房型问题</Option>
                            <Option key={4} value={4}>护理师投诉</Option>
                            <Option key={5} value={5}>客户购物，质量不满意</Option>
                            <Option key={6} value={6}>客户投诉</Option>
                            <Option key={7} value={7}>摄影投诉</Option>
                            <Option key={8} value={8}>产康客诉</Option>
                            <Option key={9} value={9}>宝宝未入住退款</Option>
                            <Option key={10} value={10}>产康未做，顾客身体原因</Option>
                            <Option key={11} value={11}>产康项目客户不想做</Option>
                            <Option key={12} value={12}>对公付款退款</Option>
                            <Option key={13} value={13}>客户多付款</Option>
                            <Option key={14} value={14}>客户提前出所</Option>
                            <Option key={15} value={15}>客户自身原因</Option>
                            <Option key={16} value={16}>流产</Option>
                            <Option key={17} value={17}>满房原因</Option>
                            <Option key={18} value={18}>团购券退款</Option>
                            <Option key={19} value={19}>押金退款</Option>
                            <Option key={20} value={20}>意向金退款</Option>
                            <Option key={21} value={21}>转店退款</Option>
                        </Select>
                    </Col>
                    <Col span={10}><Input placeholder="退款金额" value={el.refund_amount} onChange={(e) => {
                        handleChange2(index, 'refund_amount', e.target.value)
                    }} /></Col>

                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>)}

                <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加退款</Button>
            </div>
        </Modal>


        {/* 录入产康数据 */}
        <Modal title="录入产康数据" visible={visible2} onOk={() => {
            // 提交录入
            baseAxiosComplete.post('/finance_center/business/add_chankang', {
                store_id: form2.getFieldValue('store_id'),
                entry_date: form2.getFieldValue('entry_date') ? form2.getFieldValue('entry_date').format('YYYY-MM-DD') : null,
                total_paid_amount: form2.getFieldValue('total_paid_amount'),
                cash_paid_amount: form2.getFieldValue('cash_paid_amount'),
                photo_total_paid_amount: form2.getFieldValue('photo_total_paid_amount'),
                photo_cash_paid_amount: form2.getFieldValue('photo_cash_paid_amount'),
                refund_detail: reciveMoneyData[0].refund_reason === undefined ? [] : reciveMoneyData,

            }).then(res => {
                if (res.status === 0) {
                    resetForm()
                    setVisible2(false)
                    resetV2()
                }
            })

        }} onCancel={() => {
            setVisible2(false)
            resetV2()
        }}>

            <div>
                <p style={{ margin: '0 0 10px 0', fontSize: 16 }}>带<span style={{ color: 'red' }}>*</span>号为必填项</p>
                <Form form={form2} {...formItemLayout}>
                    <Form.Item required label="选择门店" name="store_id" >
                        <SelectStores />
                    </Form.Item>
                    <Form.Item required label="日期" name="entry_date" >
                        <DatePicker />
                    </Form.Item>
                    <Form.Item required label="产康总实收" name="total_paid_amount" tooltip="产康总实收不包含摄影胎发">
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="产康现金实收" name="cash_paid_amount" >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="摄影胎发总实收" name="photo_total_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="摄影胎发现金实收" name="photo_cash_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                </Form>

                {reciveMoneyData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={10}>
                        <Select placeholder="退款原因" value={el.refund_reason} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange2(index, 'refund_reason', v)
                        }}>
                            <Option key={1} value={1}>宝宝生病投诉</Option>
                            <Option key={2} value={2}>餐食投诉</Option>
                            <Option key={3} value={3}>房型问题</Option>
                            <Option key={4} value={4}>护理师投诉</Option>
                            <Option key={5} value={5}>客户购物，质量不满意</Option>
                            <Option key={6} value={6}>客户投诉</Option>
                            <Option key={7} value={7}>摄影投诉</Option>
                            <Option key={8} value={8}>产康客诉</Option>
                            <Option key={9} value={9}>宝宝未入住退款</Option>
                            <Option key={10} value={10}>产康未做，顾客身体原因</Option>
                            <Option key={11} value={11}>产康项目客户不想做</Option>
                            <Option key={12} value={12}>对公付款退款</Option>
                            <Option key={13} value={13}>客户多付款</Option>
                            <Option key={14} value={14}>客户提前出所</Option>
                            <Option key={15} value={15}>客户自身原因</Option>
                            <Option key={16} value={16}>流产</Option>
                            <Option key={17} value={17}>满房原因</Option>
                            <Option key={18} value={18}>团购券退款</Option>
                            <Option key={19} value={19}>押金退款</Option>
                            <Option key={20} value={20}>意向金退款</Option>
                            <Option key={21} value={21}>转店退款</Option>
                        </Select>
                    </Col>
                    <Col span={10}><Input placeholder="退款金额" value={el.refund_amount} onChange={(e) => {
                        handleChange2(index, 'refund_amount', e.target.value)
                    }} /></Col>

                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>)}

                <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加退款</Button>
            </div>
        </Modal>


        {/* 录入领佳数据 */}
        <Modal title="录入领佳数据" visible={visible3} onOk={() => {
            // 提交录入
            baseAxiosComplete.post('/finance_center/business/add_lingjia', {
                store_id: form3.getFieldValue('store_id'),
                entry_date: form3.getFieldValue('entry_date') ? form3.getFieldValue('entry_date').format('YYYY-MM-DD') : null,
                agreement_total_amount: form3.getFieldValue('agreement_total_amount'),
                total_paid_amount: form3.getFieldValue('total_paid_amount'),
                cash_paid_amount: form3.getFieldValue('cash_paid_amount'),
                train_total_paid_amount: form3.getFieldValue('train_total_paid_amount'),
                certificate_total_paid_amount: form3.getFieldValue('certificate_total_paid_amount'),
                certificate_cash_paid_amount: form3.getFieldValue('certificate_cash_paid_amount'),
                refund_detail: reciveMoneyData[0].refund_reason === undefined ? [] : reciveMoneyData,

            }).then(res => {
                if (res.status === 0) {
                    resetForm()
                    setVisible3(false)
                    resetV3()
                }
            })

        }} onCancel={() => {
            setVisible3(false)
            resetV3()
        }}>

            <div>
                <p style={{ margin: '0 0 10px 0', fontSize: 16 }}>带<span style={{ color: 'red' }}>*</span>号为必填项</p>
                <Form form={form3} {...formItemLayout}>
                    <Form.Item required label="选择门店" name="store_id" >
                        <SelectStores />
                    </Form.Item>
                    <Form.Item required label="日期" name="entry_date" >
                        <DatePicker />
                    </Form.Item>
                    <Form.Item required label="领佳合同总金额" name="agreement_total_amount" >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="领佳总实收" name="total_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="领佳现金实收" name="cash_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="培训总实收" name="train_total_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="培训现金实收" name="train_cash_paid_amount" >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="发证总实收" name="certificate_total_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                    <Form.Item required label="发证现金实收" name="certificate_cash_paid_amount"  >
                        <Input placeholder="请输入数字" />
                    </Form.Item>
                </Form>

                {reciveMoneyData.map((el, index: number) => <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                    <Col span={10}>
                        <Select placeholder="退款原因" value={el.refund_reason} style={{ width: '100%' }} onChange={(v: number) => {
                            handleChange2(index, 'refund_reason', v)
                        }}>
                            <Option key={1} value={1}>宝宝生病投诉</Option>
                            <Option key={2} value={2}>餐食投诉</Option>
                            <Option key={3} value={3}>房型问题</Option>
                            <Option key={4} value={4}>护理师投诉</Option>
                            <Option key={5} value={5}>客户购物，质量不满意</Option>
                            <Option key={6} value={6}>客户投诉</Option>
                            <Option key={7} value={7}>摄影投诉</Option>
                            <Option key={8} value={8}>产康客诉</Option>
                            <Option key={9} value={9}>宝宝未入住退款</Option>
                            <Option key={10} value={10}>产康未做，顾客身体原因</Option>
                            <Option key={11} value={11}>产康项目客户不想做</Option>
                            <Option key={12} value={12}>对公付款退款</Option>
                            <Option key={13} value={13}>客户多付款</Option>
                            <Option key={14} value={14}>客户提前出所</Option>
                            <Option key={15} value={15}>客户自身原因</Option>
                            <Option key={16} value={16}>流产</Option>
                            <Option key={17} value={17}>满房原因</Option>
                            <Option key={18} value={18}>团购券退款</Option>
                            <Option key={19} value={19}>押金退款</Option>
                            <Option key={20} value={20}>意向金退款</Option>
                            <Option key={21} value={21}>转店退款</Option>
                        </Select>
                    </Col>
                    <Col span={10}><Input placeholder="退款金额" value={el.refund_amount} onChange={(e) => {
                        handleChange2(index, 'refund_amount', e.target.value)
                    }} /></Col>

                    <Col span={1} style={{ paddingTop: 4 }}>
                        <DeleteOutlined onClick={() => {
                            deleteRow(index)
                        }} style={{ cursor: 'pointer' }} />
                    </Col>
                </Row>)}

                <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加退款</Button>
            </div>
        </Modal>
    </div>)
}